import ProjectHistoryView from "./ProjectHistoryView";
import ImageModal from "../../ui/ImageModal";
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@nextui-org/react";
import { deleteHistoryImageDataByURL, getHistoryImageData } from "../../models/firebaseModel";

const ProjectHistory = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageList, setImageList] = useState([]);

  const handleDelete = () => {
    deleteHistoryImageDataByURL(selectedImage);
    setSelectedImage(null);
    onClose(); // Use onClose to close the modal
  };

  const openModal = (imageSrc) => {
    console.log("Open modal with image: ", imageSrc);
    setSelectedImage(imageSrc);
    onOpen();
  };

  useEffect(() => {
    getHistoryImageData(setImageList);
    console.log(imageList);
  }, []);

  return (
    <div className="h-full overflow-auto">
      <ProjectHistoryView imageList={imageList} openModal={openModal} />
      <ImageModal isOpen={isOpen} onClose={onClose} imageSrc={selectedImage} onDelete={handleDelete} showDeleteButton={true} />
    </div>
  );
};

export default ProjectHistory;
